/**
 * @file
 * Created by kongweimin on 17/7/17.
 * @DataTime ''
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const Hello = r => require(['views/hello'], r);
const NotFound = r => require(['views/error/404'], r);

const Index = r => require(['views/index'], r);
const error500 = r => require(['views/error/500'], r);

// const  = r => require(['views/error/404'], r);
const Login = r => require(['views/user/login'], r);
import Agree from 'views/user/agree'
import Base from 'components/base';
import store from '../vuex/store';
// import Index from 'views/index';
// import Login from 'views/user/login';
import Register from 'views/user/register';
import RegisterSuc from 'views/user/regSucc';
import Callback from 'views/user/callback';
import Center from 'views/user/center';
import Promise from 'views/user/promise';
import Message from 'views/user/message';
//基金管理
import Fund from 'views/fund/index'
import FundDetail from 'views/fund/detail'
//净值管理
import Net from 'views/netMana/index'
import NetDetail from 'views/netMana/detail'

//公司管理
import Company from 'views/company/index'
import CompanyDetail from 'views/company/detail'

//基金经理管理
import Manager from 'views/manager/index'
import ManagerDetail from 'views/manager/detail'
// 引入子路由
import centerChild from './center'

// import store from '../vuex/store';
// 根目录
const rootPath = '';
function getNetData(route){
    return store.state.dataItem;
}
const router =  new VueRouter({
    routes: [
        {
            path: '/',
            meta: {
                title : '首页-私募', //// 页面设置<title></title>
            },
            component : Index,
            name: 'home'
            // redirect: {  //重定向
            //   name: 'hello'
            // }
        },
        {
            path:'/agree',
            meta: {
                title : '金斧子服务协议-私募', //// 页面设置<title></title>
            },
            component : Agree,
            name: 'agree'
        },
        {
            path: '/login',
            meta: {
                title : '登录-私募',
            },
            component : Login,
            name: 'login'
        },
        {
            path: '/register',
            meta: {
                title : '注册-私募',
            },
            component : Register,
            name: 'register'
        },
        {
            path: '/registerSuc',
            meta: {
                title : '注册-私募',
            },
            component : RegisterSuc,
            name: 'registerSuc'
        },
        {
            path: '/callback',
            meta: {
                title : '找回密码-私募',
            },
            component : Callback,
            name: 'callback'
        },
        {
            path: '/center',
            meta: {
                title : '个人中心-私募',
            },
            component : Center,
            name: 'center',
            alias: '/user',
        },
        {
            path: '/message',
            meta: {
                title : '消息中心-私募',
            },
            component : Message,
            name: 'message',
            alias: '/msg',
        },
        {
            path: '/fund',
            component : Base,
            children: [
                {
                    path: '',
                    name: 'fund',
                    component: Fund,
                    meta: {
                        title : '基金管理-私募',
                    },
                },
                {
                    path: ':id/:type',
                    name:'fundDetail',
                    alias:'/fundDetail/:id',
                    component: FundDetail,
                    meta:{
                        title:'基金管理-详情-私募中心'
                    },
                }
            ]
        },

        {
            path: '/manager/:id/:type',
            name:'managerDetail',
            component: ManagerDetail,
            meta:{
                title:'基金经理管理-详情-私募中心'
            },
        },
        {
            path: '/manager',
            name:'manager',
            component: Manager,
            meta:{
                title:'基金经理管理-私募中心'
            },
        },
        {
            path: '/net/:id/:type',
            name:'netDetail',
            component: NetDetail,
            meta:{
                title:'净值管理-详情-私募中心'
            },
            props:{
                dataItem: getNetData
            }
        },
        {
            path: '/net',
            name:'net',
            component: Net,
            meta:{
                title:'净值管理-私募中心'
            },
        },
        {
            path: '/company/:id/:type',
            name:'companyDetail',
            component: CompanyDetail,
            meta:{
                title:'公司管理-详情-私募中心'
            },
        },
        {
            path: '/company',
            name:'company',
            component: Company,
            meta:{
                title:'公司管理-私募中心'
            },
        },
        {
            path: '/promise',
            meta: {
                title : '承诺函-私募',
            },
            component : Promise,
            name: 'promise',
        },
        {
            path: '/hello',
            meta: {
                title : '首页',
            },
            component: Hello,
            name: 'hello',
            children:[
                {   path:'ll',
                    component : Login
                }
            ]
        },
        {path: '/500', component: error500, name: '500'},
        {path: '*', component: NotFound, name: 'notfound'}
    ]
});
// 页面路由
// const routes =

// 404 页
// routes.push({path: '*', component: NotFound, name: 'notfound'});


// const routers = new VueRouter({
//    mode: 'history',
//    routes: routes
// });

export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js